import React from 'react';

export default function WeekDayHeaders({ weekDays = [], isMobile, visibleDays }) {
  return (
    <div className="flex border-b border-border bg-surface shrink-0">
      <div className="day-header-spacer w-20 border-r border-border" />
      <div className="week-day-headers flex-1 grid grid-cols-7 text-center">
        {weekDays.map((d) => {
          const hidden = isMobile && !visibleDays.has(d.day);
          return (
            <div
              key={d.iso || d.day}
              className={`day-header-cell py-4 border-r border-border flex flex-col items-center last:border-r-0 ${
                d.today ? 'bg-primary/5' : ''
              } ${d.weekend ? 'bg-background-light/50' : ''} ${hidden ? 'is-mobile-hidden' : ''}`}
              data-day={d.day}
            >
              <span
                className={`text-xs mb-1 ${
                  d.today
                    ? 'font-bold text-primary'
                    : d.weekend
                      ? 'font-medium text-text-secondary/60'
                      : 'font-medium text-text-secondary'
                }`}
              >
                {d.short}
              </span>
              {d.today ? (
                <span className="w-9 h-9 flex items-center justify-center bg-primary text-white rounded-full text-base font-bold">
                  {d.dayNum}
                </span>
              ) : (
                <span
                  className={`text-base font-semibold ${
                    d.weekend ? 'text-text-secondary/60' : 'text-text-main'
                  }`}
                >
                  {d.dayNum}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
